import ButtonBase from '@mui/material/ButtonBase';
import { User, X } from 'lucide-react';

type Props = { analysts: string[]; currency: string; onRemoveAnalyst: (name: string) => void; onRemoveCurrency: () => void };

/** The analysts and instrument in use, each removable in one click. */
export function ActiveFilterChips({ analysts, currency, onRemoveAnalyst, onRemoveCurrency }: Props) {
  return (
    <>
      {analysts.map((a) => (
        <ButtonBase key={a} aria-label={`Remove analyst ${a}`} onClick={() => { onRemoveAnalyst(a); }} sx={chipSx}>
          <User size={13} aria-hidden />
          {a}
          <X size={13} aria-hidden />
        </ButtonBase>
      ))}
      {currency ? (
        <ButtonBase aria-label={`Remove instrument ${currency}`} onClick={onRemoveCurrency} sx={chipSx}>
          {currency}
          <X size={13} aria-hidden />
        </ButtonBase>
      ) : null}
    </>
  );
}

const chipSx = {
  gap: 0.75,
  height: 32,
  px: 1.25,
  borderRadius: 4,
  fontSize: '0.8125rem',
  fontWeight: 500,
  border: 1,
  borderColor: 'color-mix(in srgb, var(--mui-palette-primary-main) 25%, transparent)',
  bgcolor: 'surface.accentSoft',
  color: 'primary.dark',
  '@keyframes chipIn': { from: { opacity: 0, transform: 'scale(0.92)' }, to: { opacity: 1, transform: 'none' } },
  animation: 'chipIn 180ms ease-out both',
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
  '&:hover': { borderColor: 'primary.light' },
} as const;
